/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Shipping_QuotedInputs */

const en_orders_shipping_quoted = /** @type {(inputs: Orders_Shipping_QuotedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shipping Cost`)
};

const es_orders_shipping_quoted = /** @type {(inputs: Orders_Shipping_QuotedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Costo de envío`)
};

/**
* | output |
* | --- |
* | "Shipping Cost" |
*
* @param {Orders_Shipping_QuotedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_shipping_quoted = /** @type {((inputs?: Orders_Shipping_QuotedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Shipping_QuotedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_shipping_quoted(inputs)
	return es_orders_shipping_quoted(inputs)
});